import React, { useState, useEffect, useRef } from 'react'
import './userdashboardreferrals.css'
import { useNavigate } from 'react-router-dom'
import { MdOutlineContentCopy, MdOutlineDone } from 'react-icons/md'
import { FiLink, FiUsers } from 'react-icons/fi'
import Loader from '../Loader'
import Userdashboardheader from '../userdashboardheader/Userdashboardheader'
import DashboardTopbar from '../dashboardShell/DashboardTopbar'
import PageHero from '../dashboardShell/PageHero'

const Userdashboardreferrals = ({ route }) => {
  const navigate = useNavigate()
  const [userData, setUserData] = useState()
  const [loader, setLoader] = useState(false)
  const [copied, setCopied] = useState(false)
  const clipRef = useRef(null)

  useEffect(() => {
    setLoader(true)
    if (localStorage.getItem('token')) {
      const getData = async () => {
        const res = await (await fetch(`${route}/api/getData`, {
          headers: { 'x-access-token': localStorage.getItem('token') }
        })).json()
        setUserData(res)
        if (res.status === 'error') navigate('/login')
        setLoader(false)
      }
      getData()
    } else {
      navigate('/login')
    }
  }, [])

  const referralLink = `ollarinmirror.com/user/${userData?.username || userData?.referral || ''}`

  const copyLink = () => {
    navigator.clipboard.writeText(referralLink)
    setCopied(true)
    setTimeout(() => setCopied(false), 2500)
  }

  return (
    <div className="ud-layout">
      {loader && <Loader />}
      <Userdashboardheader route={route} />

      <div className="ud-main">
        <DashboardTopbar route={route} title="Referrals" />

        <div className="ud-content">
          <PageHero
            icon={<FiUsers />}
            eyebrow="Referrals"
            title="Invite friends, earn commission"
            description="Share your referral link. You earn 10% of every deposit made by people who sign up with it."
          >
            <div className="ud-hero-figure">
              <span>Referrals</span>
              <strong>{userData?.referred?.length || 0}</strong>
            </div>
            <div className="ud-hero-figure">
              <span>Commission</span>
              <strong>${Number(userData?.refBonus || 0).toLocaleString()}</strong>
            </div>
          </PageHero>


          {/* Referral Link Card */}
          <div className="ud-card udr-link-card">
            <div className="udr-link-header">
              <div className="udr-link-icon"><FiLink /></div>
              <div>
                <p className="udr-link-title">Your Referral Link</p>
                <p className="udr-link-sub">Earn <strong>10%</strong> of every deposit made by your referrals</p>
              </div>
            </div>
            <div className="udr-copy-row">
              <input ref={clipRef} readOnly value={referralLink} className="udr-link-input" />
              <button className="udr-copy-btn" onClick={copyLink}>
                {copied ? <><MdOutlineDone /> Copied!</> : <><MdOutlineContentCopy /> Copy</>}
              </button>
            </div>
          </div>


          {/* Referral Table */}
          <div className="ud-section-header" style={{marginTop:'28px'}}>
            <h2>Referred users</h2>
            <p>People who joined with your link.</p>
          </div>

          {userData?.referred?.length > 0 ? (
            <div className="ud-table-wrap">
              <table className="ud-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Joined</th>
                    <th>Commission</th>
                  </tr>
                </thead>
                <tbody>
                  {userData.referred.map((ref, i) => (
                    <tr key={i}>
                      <td>{ref.firstname} {ref.lastname}</td>
                      <td style={{color:'rgba(255,255,255,0.4)', fontSize:'0.8rem'}}>{ref.email}</td>
                      <td style={{color:'rgba(255,255,255,0.4)', fontSize:'0.8rem'}}>{ref.date}</td>
                      <td style={{fontVariantNumeric:'tabular-nums', fontWeight:600, color:'rgb(72,199,130)'}}>${ref.refBonus || 0} USD</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="ud-card ud-empty">
              <p>You haven't referred anyone yet. Share your link to start earning commission.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Userdashboardreferrals
